export const EDITOR_PLACEHOLDER = 'Start writing...';
